import React, { Component } from "react";
import { find } from "lodash";
import DesignTool from "../../designtool";
import {
  MES_NOT_SELECED_RING,
  RODEO_TYPE,
  CHARM_TYPE,
  IMAGE_HEIGHT_DEFAULT
} from "../../const";

export default class CartTotals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalStonePrice: 0,
      totalMaterialSize: 0
    };
  }

  componentDidMount() {
    let _this = this;

    DesignTool.on("onchange", function() {
      let items = [...DesignTool.getItems()];
      let {
        productList,
        designInfo,
        handleUpdateState
        // tmpDesignInfo,
        // tmpListItem
      } = _this.props;
      let total = 0;
      let totalSize = 0;

      // if (items.length > tmpListItem.length && tmpDesignInfo.ringId !== 0) {
      //   handleUpdateState("isShowDialogMessage", true);
      //   handleUpdateState("dialogMessage", MES_NOT_SELECED_RING);
      //   return;
      // }

      // Check ring not selected
      if (designInfo.ringSize === null) {
        DesignTool.clearItems();

        handleUpdateState("isShowDialogMessage", true);
        handleUpdateState("dialogMessage", MES_NOT_SELECED_RING);
        return;
      }

      for (var i = 0; i < items.length; i++) {
        let item = find(productList, function(cir) {
          return cir.id === items[i].productID;
        });
        if (item !== undefined) {
          let sizes = item.sizes;
          let size = find(sizes, function(s) {
            return s.id === items[i].sizeID;
          });
          if (size !== undefined) {
            total += size.price;
          }
        }
      }

      // get total size materials
      if (items) {
        items.forEach(item => {
          if (item.productType === RODEO_TYPE) {
            totalSize += (item.imageSize * item.size) / IMAGE_HEIGHT_DEFAULT;
          } else if (item.productType === CHARM_TYPE) {
            totalSize += item.hookPos
              ? (item.hookPos.hookW / IMAGE_HEIGHT_DEFAULT) * item.size
              : 0;
          } else {
            totalSize += item.size;
          }
        });
      }

      _this.setState({
        totalStonePrice: total,
        totalMaterialSize: totalSize
      });
    });

    // check remove when change ring <=> ring
    DesignTool.on("onremove", function() {
      let items = DesignTool.getItems();
      let { tmpDesignInfo, tmpListItem, handleUpdateState } = _this.props;

      if (tmpDesignInfo.ringId !== 0 && tmpListItem.length > 0) {
        handleUpdateState("tmpListItem", [...items]);
      }
    });
  }

  render() {
    let {
      designInfo,
      isResetDesign,
      handleUpdateState,
      tmpDesignInfo,
      isKeepData
    } = this.props;
    let { totalStonePrice, totalMaterialSize } = this.state;
    let totalPrice = designInfo.ringSize / 10;

    // Check reset design
    if (isResetDesign) {
      this.setState({ totalStonePrice: 0, totalMaterialSize: 0 });
      handleUpdateState("isResetDesign", false);
    }

    return (
      <div className="header_total">
        <div className="total_item total_item_size">
          <span className="span_text">合計サイズ</span>
          <span>
            {/* {tmpDesignInfo.ringId !== 0 && !isKeepData
              ? ""
              : `${(totalMaterialSize / 10).toFixed(2) +
                  "/" +
                  totalPrice.toFixed(2)} cm`} */}
            {`${(totalMaterialSize / 10).toFixed(2)}`}<span>cm</span>
          </span>
        </div>
        <div className="total_item total_item_price">
          <span className="span_text">合計金額</span>
          <span>
            {/* {tmpDesignInfo.ringId !== 0 && !isKeepData
              ? ""
              : `${totalStonePrice + designInfo.ringPrice}円`} */}

            {`${totalStonePrice + designInfo.ringPrice}`}<span>円</span>
          </span>
        </div>
      </div>
    );
  }
}
